import axios from "axios";
import ConstantList from "../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/related-person";

export const pagingRelatedPersons = (searchObject) => {
  var url = API_PATH + "/paging-related-persons";
  return axios.post(url, searchObject);
};

export const getRelatedPerson = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRelatedPerson = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRelatedPerson = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRelatedPerson = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

